module.exports = "<div class=\"ui-select-no-choice selectize-dropdown\"\n    ng-show=\"$select.items.length == 0\">\n    <div class=\"selectize-dropdown-content\">\n        <div data-selectable=\"\" ng-transclude></div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src/selectize/no-choice.tpl.html
// module id = 468
// module chunks = 0